<template>
  <div class="services" id="services">
    <div class="container">
      <h1 class="section-title text-center">Services</h1>
      <h4
        class="section-subtitle text-center"
      >We have expert end-to-end capabilities to inspire and deliver growth.</h4>

      <div class="row pt-5">
        <div class="col-md-3" v-for="(item,index) in items" :key="item.title">
          <div class="item mt-3">
            <h2 class="item-title text-center">
              <i :class="item.icon"></i>
              {{item.title}}
            </h2>
            <p class="item-desc">{{item.desc}}</p>
            <div class="d-flex" @click="readMore(index)">
              <div class="form-group program-btn">
                <!-- <i class="fas fa-images mr-2"></i> -->
                Read More
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="read-more" :width="800" height="auto" :scrollable="true" :adaptive="true">
      <button class="btn btn-danger float-right mt-1 mr-1" @click="$modal.hide('read-more')">Close</button>
      <div class="p-5 modal-item">
        <p class="modal-title">
          <i :class="currentSelection.icon"></i>
          {{currentSelection.title}}
        </p>
        <p v-html="currentSelection.desc"></p>
      </div>
    </modal>
  </div>
</template>


<script>
export default {
  data() {
    return {
      currentSelection: {},
      items: [
        {
          icon: "fas fa-paper-plane",
          title: "Media Planning",
          desc:
            "We at Adpad first understand our clients requirement and set an objective. With alignment to that objective we plan the best media mix which includes all ATL, BTL and TTL. We schedule the media as per the reach to the target audience to achieve the desired reach and frequency. Plan the media with high coverage in the most feasible and effective cost(s)"
        },
        {
          icon: "fas fa-paper-plane",
          title: "Media Buying",
          desc:
            "We believe procuring the best media space for your business is essential to generating the best results from your brand marketing therefore we make clients’ media investments impactful and results-driven. We provide the best media options which are extremely cost-effective and facilitate customer acquisition through our buying services and media partners. We feel privileged to provide performance rich media solutions."
        },
        {
          icon: "fas fa-users",
          title: "Audience Development & Strategy",
          desc:
            "We embrace a people-centric approach to media buying. Our team analyzes clients’ current and historical audience data to develop a strategically sound and targeted media approach that is tailored for their vertical and specific KPIs"
        },
        {
          icon: "fas fa-chart-pie",
          title: "Analytics & Data Visualization",
          desc:
            "Our team creates custom-built marketing and media data visualization dashboards for clients. Each dashboard is developed with the goal of creating a 360* view of how all media (paid, organic, PR, etc.) is driving and affecting overall business objectives. Dashboards are real time and are in an easy-to-read, digestible, sortable and exportable format."
        },
        {
          icon: "fas fa-chess-queen",
          title: "Media Strategy",
          desc:
            "With a team of experience more that of two decade in this field we have been continuously changing ourself with respect to the time. We propose a better strategy for our clients that best matches the initial and future brand development need which is backed with a sound media research from our end. Our teams always have an eye on performance and continuously optimize media strategies with efforts focused on moving every rupee toward the best-performing channels and partners in order to deliver maximum ROI for our clients."
        },
        {
          icon: "fas fa-tv",
          title: "Television Media Planning & Buying",
          desc:
            "Be it a national or regional Adpad has got you all it takes for a better and efficient television media planning and buying. Our team works on their fullest to give your brand the best reach and response out of the budget so allocated. We are one step ahead of the traditional TV space buying and selling. We work on how to optimize the response and benefits from the available resources on hand analyzing he target market and audience that best fits the brand."
        },
        {
          icon: "",
          title: "Digital Media Planning & Buying",
          desc:
            "With the increase in people spending time over digital media, Adpad has developed its way to a effective digital media planning and buying. We work on identifying the right space for your brand in the digital platform that generates the best feed. Our Digital media stands large on not just limiting its work to social media. We work on generating traffic to your websites as well as getting more aware on the brand through various digital platforms in trend which includes DTA’s, various online portals and many more."
        },
        {
          icon: "fas fa-broadcast-tower",
          title: "Radio Media Planning & Buying",
          desc:
            "Throughout our years in business, Adpad has crafted hundreds of radio campaigns geared to achieve extensive growth. No surprise that we have earned a reputation as an agency that “knows radio.” Technology is enhancing the radio listener experience and creating new opportunities for advertisers to reach and engage them “beyond the dial.” With so many options out there, how do you know you’re making the best media selections? Our team of seasoned radio buyers will select the most appropriate response-driving formats, from terrestrial and satellite radio that best matches the need. "
        },
        {
          icon: "fas fa-print",
          title: "Print Media Planning & Buying ",
          desc:
            "With its partnership with more that hundreds of Newspaper be it a national and regional Aadpad has a strong relationship with the print media house. At Adpad we understand our clients target customer and suggest them with the best print media to cater their need ensuring a smooth and sound relationship with all the print media partners. Also we offer an exclusive media rates that best matches your requirement and also the reliable and reasonable in town. "
        },
        {
          icon: "",
          title: "Publicity/Pr",
          desc:
            "At Ad Pad, we use our analytics capabilities to spot emerging trends that are ripe for media comment and campaigns, and help clients maximize the quality and quantity of media coverage, all the while measuring the impact obsessively and delivering PR success that also leads to business growth."
        },
        {
          icon: "fas fa-ad",
          title: "Other Services",
          desc:
            "Beside this we also provide our clients the service of broadcast which includes broadcast of documentaries, serials and many more. Apart from this we also provide our client with competitive SOV reporting that best serves their need to know the scenario of media usage by competitors. "
        }
      ]
    };
  },
  methods: {
    readMore(index) {
      this.currentSelection = this.items[index];
      this.$modal.show("read-more");
    }
  }
};
</script>

<style scoped>
.services {
  padding: 60px 0;
  border-top: 1px solid #e5e5e5;
}

.item {
  padding: 15px;
  border-radius: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-desc {
  /* height: 150px; */
text-align: justify;
  overflow: hidden;
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-line-clamp: 5; /* number of lines to show */
   -webkit-box-orient: vertical;
}
.item-title {
  font-weight: bold;
  color: #111;
  font-size: 1.2rem;
  min-height: 50px;
}

.program-btn {
  font-size: 14px;
  text-transform: capitalize;
  text-decoration: underline;
  /* border: 3px solid #111111; */
  /* padding: 9px 20px; */
  color: #111111;
  cursor: pointer;
  display: inline-block;
  /* font-weight: bold; */
}

.program-btn i {
  font-size: 20px;
}

.modal-item i {
  color: #111;
  font-size: 28px;
}

.modal-item .modal-title {
  font-size: 28px;
  color: #111;
  padding-bottom: 16px;
}
</style>